import { render } from "./WalletAddress.vue?vue&type=template&id=9ad0f502&scoped=true"
import script from "./WalletAddress.vue?vue&type=script&lang=js"
export * from "./WalletAddress.vue?vue&type=script&lang=js"

import "./WalletAddress.vue?vue&type=style&index=0&id=9ad0f502&lang=scss&scoped=true"

import exportComponent from "H:\\git\\Net_Web_LandingVue\\vue-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ad0f502"]])

export default __exports__